import { FC } from "react";
import { isValid, parseISO, format } from "date-fns";
import { cn } from "@src/lib/utils/cn";
import { inputFieldClassName } from "@src/lib/ui/Input";

export type DateTimeInputType = "datetime-local" | "date";

type Props = {
  value?: Date | null | undefined;
  required?: boolean;
  onChange: (val: Date) => void;
  disabled?: boolean;
  type?: DateTimeInputType;
  min?: string;
  max?: string;
  className?: string;
};

const TYPE_TO_FORMAT: { [key: string]: string } = {
  "datetime-local": "yyyy-MM-dd'T'HH:mm",
  date: "yyyy-MM-dd",
};

const DateTimeField: FC<Props> = ({
  value,
  required,
  onChange,
  disabled = false,
  type = "datetime-local",
  min = "",
  max = "",
  className,
}) => {
  return (
    <input
      type={type}
      required={required}
      min={min}
      max={max}
      disabled={disabled}
      className={cn(
        // The Input field look; block (not flex/self-stretch) so it sizes
        // like the native control it always was.
        inputFieldClassName,
        "block self-auto cursor-text",
        className,
      )}
      value={fmtDateForInput(type, value)}
      onChange={(event) => {
        const dateStr = event?.target?.value;
        const newDate = parseISO(dateStr);
        if (newDate && isValid(newDate)) {
          onChange(newDate);
        }
      }}
    />
  );
};

export default DateTimeField;

export function fmtDateForInput(
  type: string,
  date?: Date | null | undefined,
): string {
  return date ? format(date, TYPE_TO_FORMAT[type]) : "";
}
